import { createContext } from '@chakra-ui/react-utils';
import { Client, Conversation } from '@twilio/conversations';
import { Dispatch } from 'react';

import { IChatState, IChatAction } from '@/components/ui/shared/conversation/Chat/Chat.reducer';

export interface IChatDataContext {
  client: Client;
  conversation: Conversation;
}

const [ChatDataProvider, useChatDataContext] = createContext<IChatDataContext>({ strict: false });
const [ChatStateProvider, useChatStateContext] = createContext<IChatState>({ strict: false });
const [ChatUpdateProvider, useChatUpdateContext] = createContext<Dispatch<IChatAction>>({ strict: false });

export {
  ChatStateProvider,
  ChatUpdateProvider,
  ChatDataProvider,
  useChatStateContext,
  useChatUpdateContext,
  useChatDataContext,
};
